import React, { useState } from 'react';
import Yup from '~/util/yup';
import { assignToLegacyReferralOptions, ClinicalTypeEnum, DisciplineEnum, getLegacyReferralOptions, type SearchUserViewModel } from '@generated';
import { FormModal } from '~/shared/forms/FormModal';
import { getSearchQueryKey } from '~/util/http/useSearch';
import { CheckboxFormField } from '~/shared/forms/controls/fields/CheckboxFormField';
import { LegacyClinicianAutocomplete } from './LegacyClinicianAutocomplete';

const validationSchema = Yup.object().shape({
	primaryCare: Yup.boolean().label('Assign to Primary Care'),
	startOfCare: Yup.boolean().label('Assign to SOC'),
	userId: Yup.string().required().label('Clinician').nullable()
});

export function ReferralAssignmentModal({
	referralId,
	disciplineId,
	startOfCare,
	onCancel,
	onSuccess
}: {
	referralId: string;
	disciplineId: number;
	startOfCare: boolean;
	onCancel: () => void;
	onSuccess: () => void;
}) {
	const [selectedClinician, setSelectedClinician] = useState<SearchUserViewModel | null>(null);
	return (
		<FormModal
			title="Assign to Referral"
			closeModal={onCancel}
			initialValues={{
				referralId,
				disciplineId,
				userId: null,
				startOfCare,
				primaryCare: !startOfCare
			}}
			saveMutation={{
				...assignToLegacyReferralOptions,
				invalidateQueryKeys: [getLegacyReferralOptions(referralId).queryKey, getSearchQueryKey('legacy-referral')]
			}}
			onSaveTransform={values => ({
				...values,
				startOfCare: startOfCare || (values.startOfCare && selectedClinician?.clinicalTypeId === ClinicalTypeEnum.RN)
			})}
			onSuccess={onSuccess}
			validationSchema={validationSchema}
		>
			<div className="grid grid-cols-1 gap-4">
				<LegacyClinicianAutocomplete
					name="userId"
					label="Clinician"
					disciplineId={disciplineId}
					startOfCare={startOfCare}
					onChangePassThrough={selected => setSelectedClinician(selected)}
				/>
				{disciplineId !== DisciplineEnum.SkilledNursing ? null : startOfCare ? (
					<CheckboxFormField name="primaryCare" hideLabel />
				) : selectedClinician?.clinicalTypeId === ClinicalTypeEnum.RN ? (
					<CheckboxFormField name="startOfCare" hideLabel />
				) : null}
			</div>
		</FormModal>
	);
}
